import { DISCONTINUED_NETWORKS } from '@/constants/constants';

type NavDetail = {
  id: number;
  detailId: string;
  label: string;
  link: string;
  dataKey?: string;
  tag?: string;
};

export const getDiscontinuedNetwork = (dataKey?: string) =>
  dataKey ? DISCONTINUED_NETWORKS[dataKey.toLowerCase()] : undefined;

/**
 * Orders the landing nav's network column: live networks first, retired ones last.
 * Any retired network the CMS has already dropped is re-added, pointing at its
 * discontinuation notice — so it keeps a home instead of vanishing from the site.
 */
export const prepareNetworkNavItems = (details: NavDetail[]): NavDetail[] => {
  const isRetired = (item: NavDetail) => !!getDiscontinuedNetwork(item.dataKey);

  const present = new Set(
    details.map((item) => item.dataKey?.toLowerCase()).filter(Boolean),
  );

  const reinjected: NavDetail[] = Object.entries(DISCONTINUED_NETWORKS)
    .filter(([key, network]) => network.navFallback && !present.has(key))
    .map(([key, network]) => ({
      ...(network.navFallback as NonNullable<typeof network.navFallback>),
      dataKey: key,
      link: network.learnMoreUrl,
    }));

  return [
    ...details.filter((item) => !isRetired(item)),
    ...details.filter(isRetired),
    ...reinjected,
  ];
};
